<!--物料报价-->
<template>
  <el-main class="bg_white wrap_box lc_rw">
    <!-- 按钮组 -->
    <LcButtons ref="lcButtons" :type="2" @btsEmit="btsEmit($event)" :planStratTime="data.baseInfo.plan_start_time_text"
      :ids="ids" :projectName="data.baseInfo.project_name" :reviewerUserId="data.baseInfo.reviewer_user_id"
      :userId="data.baseInfo.leader_user_id" :msg="data.baseInfo.msg" @getPageInfo="getPageInfo"
      :deppgetPageInfo="getPageInfo" />
    <!-- 基础信息 -->
    <div class="lc_ttop">
      <lcBaseInfo ref="addBaseInfo" type="taskInfo"></lcBaseInfo>
    </div>
    <div class="lc-bsinfo">
      <!--市场分析PPT-->
      <div class="lc_title1">物料报价</div>
      <lcwlbjtable v-model:wlbjTableData="data.wlbjTableData"></lcwlbjtable>
      <!--规格定义表-->
      <div class="lc_title1">规格定义表</div>
      <lcggdytab v-model:ggdyTableData='data.ggdyTableData' :nobts="['add', 'delet']" :prtaskId='ids'></lcggdytab>
      <!--备注-->
      <div class="lc_ttop lc_bzt">备注</div>
      <div style="padding-bottom: 50px;">
        <lctinymce :id="data.id" ref="editor" :height="data.height" :cur-value="data.remark" @input="inputContent"
          :key="data.key"></lctinymce>
      </div>
    </div>
  </el-main>
</template>
<script>
import { defineComponent, reactive, ref, onMounted, getCurrentInstance, provide } from 'vue';
import { addOrderNumber } from '../../../utils/lc'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
export default defineComponent({
  name: "wlbj",
  setup (props) {
    let route = useRouter();
    provide("project_id", route.currentRoute.value.query.id);
    const addBaseInfo = ref()
    const lcButtons = ref();
    let { proxy } = getCurrentInstance();
    const ids = ref(route.currentRoute.value.query.prBasetaskId);
    let data = reactive({
      baseInfo: {},
      ggdyTableData: [],
      wlbjTableData: [],// 物料报价
      //富文本
      height: 300,
      key: "",
      id: "",
      remark: "", // 备注
    });
    // 基本信息字段值
    let baseInfokeys = reactive({
      keyArry: ["sn", "project_sn", "name", "required_time_text", "status", "leader_user_id", "reviewer_user_id", "task_status_text", "examine_status_text", "project_id", "project_name", "plan_start_time", "plan_start_time_text", "plan_end_time", "plan_end_time_text", "end_time_text"]
    });

    onMounted(() => {
      getPageInfo();
    });
    //按钮组操作
    function getPageInfo (value) {
      proxy.$http.get("project/task/material_quotation/info", { id: route.currentRoute.value.query.prBasetaskId }).then(res => {
        if (res.errno == 200) {
          data.baseInfo = JSON.parse(JSON.stringify(res.data));
          ids.value = res.data.id;
          //规格定义表
          data.ggdyTableData = res.data.skus;
          // 物料报价
          data.wlbjTableData = addOrderNumber(res.data.quotation)
          //备注
          data.remark = res.data.remark;
          // 驳回原因
          addBaseInfo.value.data.reject = res.data && res.data.reject ? res.data.reject : ''
          // 基础信息
          baseInfokeys.keyArry.forEach(it => {
            addBaseInfo.value.taskform[it] = res.data[it];
          });
        }
        else {
          ElMessage({
            type: "success",
            message: res.errmsg
          });
        }
      });
    }
    //按钮组操作
    function btsEmit (value) {
      // 提交和审核先做保存的动作
      if (value == 'passBt' || value == 'submitBt') {
        handelSavePage(value)
      }
      // 保存
      if (value == 'saveBt') {
        handelSavePage()
      }
    }
    // 保存页面
    function handelSavePage (bttype) {
      proxy.$http.showLoading(false).post("project/task/material_quotation/edit", {
        id: data.baseInfo.id,
        leader_user_id: addBaseInfo.value.taskform["leader_user_id"],
        reviewer_user_id: addBaseInfo.value.taskform["reviewer_user_id"],
        plan_start_time: addBaseInfo.value.taskform["plan_start_time_text"],
        plan_end_time: addBaseInfo.value.taskform["plan_end_time_text"],
        remark: data.remark,
        quotation: data.wlbjTableData,
        skus: data.ggdyTableData,
      }).then(res => {
        if (res.errno == 200) {
          ElMessage({
            type: "success",
            message: res.errmsg
          })
          if (bttype == 'submitBt') {
            lcButtons.value.thesubmit(bttype)
          }
          if (bttype == 'passBt') {
            lcButtons.value.thepass(bttype)
          }
          getPageInfo()
        }
        else {
          ElMessage({
            type: "error",
            message: res.errmsg
          })
        }
      })
    }
    //富文本编辑器
    function inputContent (value) {
      data.remark = value;
    }
    return {
      data,
      ids,
      addBaseInfo, lcButtons,
      btsEmit,
      getPageInfo,
      inputContent
    };
  }
})
</script>
<style scoped lang="scss">
@import '../../../assets/style/lc.scss';
</style>